const createCsv = (data) => {
    const header = Object.keys(data[0]).join(',');
    const rows = data.map(row => Object.values(row).join(',')).join('\n');
    const csvString = `${header}\n${rows}`;
    return csvString
}

module.exports = {
    createCsv
}